<template>
	<header :class="$style['app-header']">
		<div :class="$style['app-header__col']">
			<BaseIconButton
				v-testid="'header-nav-toggle'"
				:class="$style['app-header__toggle']"
				@click="toggleStatus"
			>
				<FontAwesomeIcon
					:icon="['fal', 'bars']"
					size="lg"
				/>
			</BaseIconButton>
			<div
				v-testid="'app-logo'"
				:class="$style['app-header__logo']"
				@click="$router.push({ name: 'Dashboard:Home' })"
			>
				<div :class="$style['app-logo']" />
			</div>
		</div>
		<div :class="[$style['app-header__col'], $style['app-header__col--search']]">
			<!-- <AppHeaderSearch /> -->
		</div>
		<div :class="$style['app-header__col']">
			<AppHeaderAccount :class="$style['app-header__account']" />
		</div>

		<div :class="[$style['app-header__col'], $style['app-header__col--bell']]">
			<AppHeaderNotifications />
		</div>
	</header>
</template>
<script>
import AppHeaderAccount from './AppHeaderAccount'
import AppHeaderNotifications from './AppHeaderNotifications'
// import AppHeaderSea rch from './AppHeaderSearch'
import { TOGGLE_STATUS } from '@/store/modules/App/Aside/mutation-types'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapMutations } = createNamespacedHelpers('App/Aside')
export default {
	name: 'AppHeader',
	components: {
		// AppHeaderSearch,
		AppHeaderAccount,
		AppHeaderNotifications
	},
	computed: {
		...mapGetters({
			status: 'status'
		})
	},

	methods: {
		...mapMutations({
			toggleStatus: TOGGLE_STATUS
		})
	}
}
</script>
<style lang="scss" module>

    .app-logo {
        background-image: url("@/assets/images/recar-logo-black.svg");
        background-repeat: no-repeat;
        background-position: center;
        height: 100%;
        width: 100px;

        @include dark-mode{
            background-image: url("@/assets/images/recar-logo-color.svg");
        }

        @include nord-mode{
            background-image: url("@/assets/images/recar-logo-color.svg");
        }
    }

    .app-header {
        z-index: map-get($z-index, header);
        position: relative;
        flex-shrink: 0;
        width: 100%;
        height: map-deep-get($header, height, lg);
        display: flex;
        justify-content: space-between;
        // align-items: center;
        // background-color: color-mix(in srgb, getColor(surface) 80%, transparent);
        // -webkit-backdrop-filter: blur(8px);
        // backdrop-filter: blur(8px);
      	align-items: center;
		background-color: getColor(surface);
		box-shadow: 0 0 3px 0 rgb(0, 0, 0, 0.2);
        padding: 0 $gutter * 4;
        padding-right: $gutter * 2;

		@include dark-mode {
			border-bottom: 1px solid getColor(border);
		}

        @include media-breakpoint-down(md) {
            height: map-deep-get($header, height, sm);
            padding: 0 $gutter;
        }

        &__account {
            @include media-breakpoint-down(sm) {
                display: none;
            }
        }

        &__col {
            display: flex;
            align-items: center;
            height: 100%;

            &--search {
                flex: 1;
                justify-content: center;
                padding-right: 20px;
            }

            &--bell {
                margin-left: 20px;
                padding-right: 20px;
                border-right: 1px solid getColor(border);

                @include dark-mode {
                    border-right-color: getColor(border-darker);
                }

                @include media-breakpoint-down(sm) {
                    border-right: none;
                    margin-left: 0;
                    padding-right: 10px;
                }
            }
        }

        &__toggle {
			@include media-breakpoint-up(lg) {
               opacity: 0;
			   pointer-events: none;
            }

            margin-right: calc($gutter / 2) !important;
        }

        &__logo {
            height: 64px;
            padding-right: $gutter * 4;
            padding-left: $gutter * 2;
            cursor: pointer;

            @include media-breakpoint-only(xs) {
                padding-left: 0;
            }

            img {
                max-width: 100px;
                height: 100%;
            }
        }
    }
</style>
